"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Exceptional_1 = require("./Exceptional");
class EtudeParser {
    constructor(t, exception) {
        this.t = t;
        this.exception = exception;
        this.objects = [];
    }
    isInvalid() {
        return this.exception != null;
    }
    static of(t, exception = null) {
        return new EtudeParser(t, exception);
    }
    map(func) {
        return this.isInvalid()
            ? EtudeParser.of(null, this.exception)
            : EtudeParser.of(func(this.t));
    }
    filter(predicate, exception) {
        return this.isInvalid()
            ? this
            : (predicate(this.t)
                ? this
                : EtudeParser.of(this.t, exception));
    }
    parse(func) {
        if (this.isInvalid()) {
            return this;
        }
        const exceptional = func(this.t);
        if (!exceptional.isPresent()) {
            return EtudeParser.of(this.t, exceptional.getException());
        }
        this.objects.push(exceptional.get());
        return this;
    }
    get(func) {
        return this.isInvalid()
            ? Exceptional_1.default.empty(this.exception)
            : Exceptional_1.default.of(func(this.objects));
    }
}
exports.default = EtudeParser;
